import { ApplicationResolution } from '../applicationResolution';

export type AppURLSearchParams = {
  resolution: ApplicationResolution;
  uri?: string;
  e2eTests?: boolean;
};

export const appSearchParamsKeys = {
  resolution: 'resolution',
  uri: 'uri',
  e2eTests: 'e2e_tests',
} as const;

export type AppURLSearchParamsKeys =
  (typeof appSearchParamsKeys)[keyof typeof appSearchParamsKeys];

export function isAppURLSearchParam(
  key: string
): key is AppURLSearchParamsKeys {
  return Object.keys(appSearchParamsKeys).includes(key);
}
